import { render, staticRenderFns } from "./CanvasSource3D.vue?vue&type=template&id=718ea5b8&"
import script from "./CanvasSource3D.vue?vue&type=script&lang=ts&"
export * from "./CanvasSource3D.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports